import AppShell from './AppShell';

export default AppShell;
export { useAppShell, useShellFocus, useSidebarHold } from './AppShellContext';
export { default as SidebarMenu } from './SidebarMenu';
/** @internal для тестов приложений */
export type { ISidebarMenuProps } from './SidebarMenu';
export { default as SidebarMascots } from './SidebarMascots';
export { default as EmptyLayout } from './EmptyLayout';
export type { IAppShellMenuItem } from './sidebarMenuModel';
export { clampSidebarWidth, readSidebarPinned, saveSidebarPreference, sidebarStorageKeys } from './sidebarStorage';
export { APP_SHELL_TRANSITION_DURATION, SIDEBAR_PHONE_QUERY } from './appShellConstants';
